import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pqLexileScoreFormat',
    standalone: false
})
export class LexileScoreFormatPipe implements PipeTransform {
  public transform (text: unknown): string {
    if (text === null || text === undefined) {
      return 'unavailable';
    }

    const raw = String(text).trim();

    if (!raw || raw.toLowerCase() === 'none') {
      return 'unavailable';
    }

    const value = Number.parseInt(raw, 10);

    if (Number.isNaN(value)) {
      return raw;
    }

    let formatted = raw.endsWith('L') ? raw : raw + 'L';

    if (value < 0) {
      if (formatted[0] === '-') {
        formatted = formatted.slice(1);
      }

      formatted = 'BR' + formatted;
    }

    return formatted;
  }
}
